import React, { useContext } from "react";
import { useBalance } from "../api/funds";
import { langContext } from "../api/Lang";
import { formatPriceEuro } from "../api/priceFormat";

export default function Balance() {
    const balance = useBalance();
    const [lang] = useContext(langContext);
    const price = formatPriceEuro(Number(balance || 0), lang);

    return (
        <div className="balance-text">
            <div className="credit-icon">
                <img src="/img-assets/coins.svg" alt="" width={36} height={32} />
            </div>
            <span style={{ color: (balance || 0) < 0 ? "var(--red_error)" : undefined }}>
                {price}
            </span>
        </div>
    );
}